import { useState, useEffect } from 'react';
import '../../../entrydoor.css';

const SpacerColor = ({ value, onChange, id = 'SpacerColor', label = 'Spacer Color', disabled = false }) => {
    const defaultValue = value?.value || '';
    const [selectedOption, setSelectedOption] = useState(defaultValue);

    const spacerColorOptions = [
        { id: 1, value: 'Grey', label: 'Grey' },
        { id: 2, value: 'Black', label: 'Black' },
        { id: 3, value: 'White', label: 'White' },
    ];

    // Update selected value when value prop changes
    useEffect(() => {
        setSelectedOption(value?.value || '');
    }, [value?.value]);

    // Trigger initial onChange once when component mounts
    useEffect(() => {
        if (spacerColorOptions.length > 0 && !selectedOption) {
            const defaultOption = spacerColorOptions[0];
            const newValue = defaultOption?.value || '';
            const newLabel = defaultOption?.label || '';
            setSelectedOption(newValue);
            onChange({ value: newValue, label: newLabel });
        }
    }, []);

    const handleOptionChange = (e) => {
        const newValue = e.target.value;
        const selectedText = e.target.options[e.target.selectedIndex].text.replace(' ✔', '');

        setSelectedOption(newValue);
        onChange({ value: newValue, label: selectedText });
    };

    return (
        <div className="a-container">
            <label htmlFor={id} disabled={disabled}>
                {label}
            </label>
            <select
                disabled={disabled}
                id={id}
                value={selectedOption}
                onChange={handleOptionChange}
            >
                {spacerColorOptions.map(option => (
                    <option key={option.id} value={option.value}>
                        {selectedOption === option.value ? `${option.label} ✔` : option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SpacerColor;
